import { render, staticRenderFns } from "./SelectableInput.vue?vue&type=template&id=5478b8e9&"
import script from "./SelectableInput.vue?vue&type=script&lang=js&"
export * from "./SelectableInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports